<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Services",
          icon: "bi bi-tools",
          route: "services-index",
        },
        {
          label: "Nouveau service",
          icon: "bi bi-wrench-adjustable-circle-fill",
          route: "services-create",
        },
        {
          label: "Prix services",
          icon: "bi bi-currency-exchange",
          route: "services-prices-index",
        },
        {
          label: "Attribuer prix",
          icon: "bi bi-tag-fill",
          route: "services-prices-create",
        },
      ],
    };
  },
};
</script>
